import { GetStatistics, ModelType } from '@livv/models';
import { Box } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import BlockTitle from '../components/BlockTitle';
import StatisticCard from './StatisticCard';

interface StatisticsProps {
    statisticsOutput?: GetStatistics['output'];
}

const Statistics: FC<StatisticsProps> = ({ statisticsOutput }) => {
    const { t } = useTranslation('common');

    if (statisticsOutput?.status !== 'ok' || !statisticsOutput.statistics.length) {
        return null;
    }

    const { statistics } = statisticsOutput;

    return (
        <Box>
            <BlockTitle
                modelType={ModelType.STATISTIC}
                title={t('statistic', {
                    count: statistics.length,
                })}
            />
            {statistics.map(({ title, id }) => (
                <StatisticCard key={`statistic-${id}`} id={id} title={title} />
            ))}
        </Box>
    );
};

export default Statistics;
